import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { Device, DEVICE$ } from './device';
import { Product } from './purchase/model';

export abstract class ArmyBuilderConfig {
    abstract version: string;
    abstract apiBaseUrl: string;
    environment: string;
    paths = {
        statusEffectIcons: 'images/icons/statusEffects/'
    };

    partitionUnitsByFaction = true;
    supportedLanguages: string[];
    globalRequestHeaders: any;
    roles: { [key: string]: string };
    revenueCatAppId?: string;
    abstract settings: SettingsConfig;
    abstract products?: Product[];
    abstract purchaseKey?: string;
    abstract purchaseKeys?: {
        apple?: string;
        google?: string;
        stripe?: string;
    };
    enableQRCode?: boolean;
    device$: Observable<Device> = DEVICE$;
    enableStripePurchases?: boolean;

    loginPollTime = 1000 * 60 * 5; // check login/subscription status every 5 minutes (though if the server throws an unknown error, for instance if the user is offline, then the app assumes the most recent status is still valid)
    loginTimeout = 1000 * 60 * 60 * 24; // if the app can't reach the server for 24 hours, log the user out

    networkTimeout = 30000;
    purchaseHandlerRedirect = '/';
}

export const ARMY_BUILDER_CONFIG: InjectionToken<ArmyBuilderConfig> = new InjectionToken<ArmyBuilderConfig>('Army Builder Config Token');

export interface SettingsConfig {
    [gameId: string]: SettingsGameConfig;
}

export interface SettingsGameConfig {
    [key: string]: SettingsFieldConfig;
}

export interface SettingsFieldConfigBoolean {
    type: 'boolean';
    defaultValue: boolean;
}

export interface SettingsFieldConfigSelect {
    type: 'select';
    defaultValue: any;
    options: { label: string; value: any }[];
}

export type SettingsFieldConfig = SettingsFieldConfigBoolean | SettingsFieldConfigSelect;
